module.exports = __webpack_public_path__ + "components/flag/static/square/bw-aca0ec5497f93d338da81e0cf6dd5190.svg";